import { Theme } from "@screencloud/screencloud-ui-components";
import styled from "styled-components";

export const TemplateCards = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  width: 100%;
  padding: 16px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;

  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  @media (max-width: ${Theme.break.mediumAlt}) {
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }

  @media (max-width: ${Theme.break.small}) {
    grid-template-columns: 1fr;
    max-height: calc(100% - 80px);
  }
`;

export const TemplateCardContainer = styled.div<{
  isSelected: boolean;
  color: string;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.02);
    .template-label {
      color: var(--color-white-100, #fff);
      background: var(--color-gray-500, #62636a);
    }
    .template-card {
      transform: scale(1.05);
    }
  }

  ${({ isSelected, color }) =>
    isSelected &&
    `
    .template-card {
      border: 2px solid ${color};
    }
    .template-label {
      color: var(--color-white-100, #fff);
      background: var(--color-black-100, #000);
    }
  `}
`;

export const TemplateCard = styled.div`
  aspect-ratio: 16 / 9;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 450px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: ${Theme.break.largeXHD}) {
    max-width: 300px;
    margin: 0 auto;
  }

  @media (max-width: ${Theme.break.small}) {
    max-width: 100%;
    margin: 0;
  }
`;

export const TemplateLabel = styled.div`
  display: inline-flex;
  height: var(--size-md, 32px);
  padding: 0px var(--spacing-lg, 16px);
  justify-content: center;
  align-items: center;
  gap: var(--spacing-xxs, 4px);

  width: fit-content;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  border-radius: var(--radius-lg, 16px);
  border: 1px solid var(--color-gray-100, #e2e3e5);
  background: var(--color-white-100, #fff);

  box-shadow: 0px 1px 2px 0px var(--color-black-5, rgba(0, 0, 0, 0.05));

  color: var(--color-black-100, #000);

  font-size: var(--font-size-sm, 14px);
  font-weight: 700;
  line-height: var(--font-line-height-sm, 20px);
`;

export const LoaderContainer = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
`;
